import { render, staticRenderFns } from "./TintometricoCor.vue?vue&type=template&id=7b4ec885"
import script from "./TintometricoCor.vue?vue&type=script&lang=js"
export * from "./TintometricoCor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports